<div id="orderresult" class="ya-typography">
  <div class="ya-page-content ya-page-content--padding ya-page-content--webshop">
    <ng-container *ngIf="checkoutpaymentmodel">
      <ng-container [ngSwitch]="checkoutpaymentmodel.done">
        <ng-container *ngSwitchCase="ResponseCode_Done.Authorised">
          <div class="inline-icon margin-down" inlineSVG="hypersoft-bestellen-bestaetigung2.svg"></div>
          <div class="title margin-down" langkey="phOrderResult_ThankYouForYourOrder"></div>
          <ng-container *ngIf="mail && mail.length > 0">
            <div class="text margin-down" [innerHTML]="confirmationmailtext"></div>
          </ng-container>
          <ng-container *ngIf="checkoutpaymentmodel && groupName && groupName.length > 0">
            <div class="hero-text margin-down" langkey="phOrderResult_Success_YourOrder"></div>
            <div class="hero-text margin-down"><span class="emphasized hero-name">{{groupName}}</span>
            </div>
          </ng-container>
          <ng-container *ngIf="ordersuccesstext">
            <div class="text margin-down" [innerHTML]="ordersuccesstext"></div>
          </ng-container>
          <div class="ya-webshop-button-container">
            <ng-container *ngIf="showReturnToHomeBtn">
              <button mat-flat-button (click)="gotoHome()">
                <span langkey="phOrderResult_ToTheHomescreen"></span>
              </button>
            </ng-container>
            <ng-container *ngIf="showReturnToURLBtn">
              <a [href]="returnURL" target="_self">
                <button mat-flat-button>
                  <span langkey="phGlobal_Return"></span>
                </button>
              </a>
            </ng-container>
          </div>
          <ng-container *ngIf="phonenumber && phonenumber.length > 0">
            <div class="text" langkey="phOrderResult_PhoneNumberForCallback"></div>
            <ng-container *ngIf="isMobile; else desktopView">
              <a [href]="'tel:' + phonenumber" class="phonenumberclick margin-down">{{phonenumber}}</a>
            </ng-container>
            <ng-template #desktopView>
              <div class="phonenumber margin-down">{{ phonenumber }}</div>
            </ng-template>
          </ng-container>
          <ng-container *ngFor="let bonus of bonuspointsHTMLs">
            <div class="bonuspoints" [innerHTML]="bonus"></div>
          </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="ResponseCode_Done.Cancelled">
          <div class="title margin-down" langkey="phOrderResult_YourOrderWasCancelled"></div>
          <div class="text margin-down" langkey="phOrderResult_DoYouWantToContinue_TEXT"></div>
          <div class="ya-webshop-button-container">
            <button mat-flat-button (click)="returnToGroupOverview()">
              <span langkey="phOrderResult_ReturnToCheckout"></span>
            </button>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="ResponseCode_Done.Error">
          <ng-container *ngTemplateOutlet="Error"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="ResponseCode_Done.Refused">
          <ng-container *ngTemplateOutlet="Error"></ng-container>
        </ng-container>
        <ng-template #Error>
          <div class="title margin-down" langkey="phOrderResult_OrderCouldNotBeAccepted"></div>
          <div class="text margin-down" langkey="phOrderResult_ThereWasAProblem_TEXT"></div>
          <div class="ya-webshop-button-container">
            <button mat-flat-button (click)="returnToGroupOverview()">
              <span langkey="phOrderResult_ReturnToCheckout"></span>
            </button>
          </div>
        </ng-template>
      </ng-container>
    </ng-container>
  </div>
</div>